import { Chat, ChatType } from '../models/chat.models';

export interface ChatState {
    enabledChats: number;
    htmlLoaded: boolean;
    loaded: boolean;
    opened: boolean;
    visible: boolean;
    active: boolean;
    enabled: boolean;
    outOfService: boolean;
    scheduleMessage: string;
    widgetLoaded: boolean;
    isButtonVisible: boolean;

    activeChat?: ChatType;

    hubType?: Chat;
    kakaoTalk?: Chat;
    mochaChat?: Chat;
    urlChat?: Chat;

    styleAdvisor?: Chat;

    isLargeButtonChat?: boolean;
}

export const chatInitialState: ChatState = {
    enabledChats: 0,
    htmlLoaded: false,
    loaded: false,
    visible: null,
    opened: false,
    active: false,
    enabled: false,
    outOfService: false,
    scheduleMessage: '',
    widgetLoaded: false,
    isLargeButtonChat: false,
    isButtonVisible: true,
};
